import React from "react";
import {Link} from "react-router-dom";

class Promotion extends React.Component {
  constructor() {
    super();
    this.state = {
      showingAlert: false,
      showingVideo1: true,
      showingVideo2: false,
      showingVideo3: false,
      showingVideo4: false,
      showingVideo5: false,
      showingVideo6: false,
      showingVideo7: false
    };
  }

  handleClickShowAlert() {
    this.setState({
      showingAlert: true
    });

    setTimeout(() => {
      this.setState({
        showingAlert: false
      });
    }, 2000);
  }

  showVideo(videoId) {
    this.setState({ "showingVideo1": false });
    this.setState({ "showingVideo2": false });
    this.setState({ "showingVideo3": false });
    this.setState({ "showingVideo4": false });
    this.setState({ "showingVideo5": false });
    this.setState({ "showingVideo6": false });
    this.setState({ "showingVideo7": false });

    const field = "showingVideo" + videoId;
    this.setState({ [field]: true });
  }

  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };
    return (
        <section className="section howvideo-section" style={{background: "#fff", padding: "100px 0"}}>

          <div className="container">
            <div className="row">

              <div className="col-lg-5">

                <div className="VideoContents">

                  <div id="video1" className="HowItVideoContents" style={{ display: this.state.showingVideo1 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-4.jpg" alt="how many devices can connect to wifi , how much data does online gaming use on mobile hotspot" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=ybGA-xaTFIo" className="center-icon" data-lity>
                        <img src="/images/play.svg" alt="how to make hotspot faster"/>
                      </a>
                    </div>
                  </div>

                  <div id="video2" className="HowItVideoContents" style={{ display: this.state.showingVideo2 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-4.jpg" alt="how many devices can connect to wifi , how much data does online gaming use on mobile hotspot" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=zA4H5XcsQ9A" className="center-icon" data-lity>
                        <img src="/images/play.svg" alt="how to make hotspot faster"/>
                      </a>
                    </div>

                  </div>

                  <div id="video3" className="HowItVideoContents" style={{ display: this.state.showingVideo3 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-1.jpg" alt="How To Troubleshoot The MightyWifi" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=7vOWa7QWtmw" className="center-icon" data-lity>
                        <img src="/images/play.svg"/>
                      </a>
                    </div>

                  </div>

                  <div id="video4" className="HowItVideoContents" style={{ display: this.state.showingVideo4 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-2.jpg" alt="how to get wifi out in the country" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=Ow4VI-MOjoo" className="center-icon" data-lity>
                        <img src="/images/play.svg" alt="how to increase mobile hotspot speed in laptop"/>
                      </a>
                    </div>
                  </div>

                  <div id="video5" className="HowItVideoContents" style={{ display: this.state.showingVideo5 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-3.jpg" alt="how to activate a tmobile sim card & how to activate t mobile hotspot device & how to activate t mobile sim card" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=M1RCG8MzuJo" className="center-icon" data-lity>
                        <img src="/images/play.svg" alt="how to increase wifi hotspot speed"/>
                      </a>
                    </div>
                  </div>

                  <div id="video6" className="HowItVideoContents" style={{ display: this.state.showingVideo6 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-5.jpg" alt="mighty wifi hotspot" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=W1s60G0DOeI" className="center-icon" data-lity>
                        <img src="/images/play.svg" alt="how much does portable wifi cost"/>
                      </a>
                    </div>
                  </div>

                  <div id="video7" className="HowItVideoContents" style={{ display: this.state.showingVideo7 ? "block": "none" }}>
                    <a href="#">
                      <img src="/images/howto-6.jpg" alt="Receiving the MightyWifi Rental Package & how does a wifi hotspot work" />
                    </a>
                    <div className="image-slider-overlay">
                      <a href="https://www.youtube.com/watch?v=_aoxE69_YKY" className="center-icon" data-lity>
                        <img src="/images/play.svg" alt="how many hours is 50gb of hotspot"/>
                      </a>
                    </div>
                  </div>

                  {/* <div className="HowItVideoContents" style={{ display: this.state.showingVideo6 ? "block": "none" }}>
                <a href="#">
                  <img src="http://i3.ytimg.com/vi/vJmSOKG36GE/hqdefault.jpg" alt="Unboxing the MightyWifi Mobile Hotspot" />
                </a>
                <div className="image-slider-overlay">
                  <a href="https://www.youtube.com/watch?v=vJmSOKG36GE" className="center-icon" data-lity>
                    <img src="/images/play.svg"/>
                  </a>
                </div>
              </div>

              <div id="video5" className="HowItVideoContents" style={{ display: this.state.showingVideo6 ? "block": "none" }}>
                <a href="#">
                  <img src="http://i3.ytimg.com/vi/FW0ytSv7tXA/hqdefault.jpg" alt="Unboxing the Power Bank PB1 for the MightyWifi" />
                </a>
                <div className="image-slider-overlay">
                  <a href="https://www.youtube.com/watch?v=FW0ytSv7tXA" className="center-icon" data-lity>
                    <img src="/images/play.svg"/>
                  </a>
                </div>
              </div> */}
                </div>
              </div>

              <div className="col-lg-7" style={PaddingStyle}>
                <div className="mt-3 features_desc">
                  <h1 className="Title">How-To Videos</h1>

                  {/* <div className="col-lg-12 no-padding">
                <ol className="HowItVideoList">
                  <li><a className="showBtn" target="1">How to Use The MightyWifi US & Global Hotspot and Troubleshoot.</a></li>
                  <li><a className="showBtn" target="2">How to Recharge Data packages and use our APP.</a></li>
                  <li><a className="showBtn" target="3">Unboxing New Device and Open and Return rental packages.</a></li>
                  <li><a className="showBtn" target="4">How to connect Mighty Powerbank accessories (sold separately)</a></li>
                </ol>
              </div> */}

                  <div className="col-lg-12 no-padding">
                    <ol className="HowItVideoList">
                      <li><a className="showBtn" onClick={ () => this.showVideo(1) }><span className="click-notice"><img src="/images/click.svg" alt="wifi global hotspot,wifi global map"/></span> How To Use The MightyWifi US & Global Hotspot V1</a></li>
                      <li><a className="showBtn" onClick={ () => this.showVideo(2) }><span className="click-notice"><img src="/images/click.svg" alt="wifi global hotspot,wifi global map"/></span> How To Use The MightyWifi US & Global Hotspot V2</a></li>
                      <li><a className="showBtn" onClick={ () => this.showVideo(3) }><span className="click-notice"><img src="/images/click.svg" alt="pocket wifi troubleshooting"/></span> How To Troubleshoot The MightyWifi</a></li>
                      <li><a className="showBtn" onClick={ () => this.showVideo(4) }><span className="click-notice"><img src="/images/click.svg" alt="recharge t mobile prepaid ,recharge tmobile,recharge tmobile prepaid"/></span> How To Recharge Data For The MightyWifi</a></li>
                      <li><a className="showBtn" onClick={ () => this.showVideo(5) }><span className="click-notice"><img src="/images/click.svg" alt="mighty works app,mightywifi app"/></span> How To Use The MightyWifi APP</a></li>
                      <li><a className="showBtn" onClick={ () => this.showVideo(6) }><span className="click-notice"><img src="/images/click.svg" alt="powerbank design,powerbank guide"/></span> How to Connect Powerbank to the MightyWifi</a></li>
                      <li><a className="showBtn" onClick={ () => this.showVideo(7) }><span className="click-notice"><img src="/images/click.svg" alt="rental car wifi password,rental unlimited data plan"/></span> Receiving the MightyWifi Rental Package</a></li>
                    </ol>
                  </div>

                  <div style={clearStyle} />
                </div>
              </div>
            </div>
          </div>

        </section>
    );
  }
}

export default Promotion;



// WEBPACK FOOTER //
// ./src/layout/HowItVideo.js